import { useMemo } from 'react'
import { useLeaseContractsList } from './useLeaseContracts'
import {
  CONTRACT_ACTIVE_GROUP,
  CONTRACT_BOOKING_GROUP
} from '../contracts.consts'

const VANTAGE_MIGRATION_DISMISSED_KEY = 'vantageMigrationNoticeDismissed'

export const useVantageMigrationNoticeCheck = () => {
  const { leaseContractsList, isLoading } = useLeaseContractsList()

  const shouldShowVantageMigrationNotice = useMemo(() => {
    if (isLoading) return false

    const isDismissed =
      localStorage.getItem(VANTAGE_MIGRATION_DISMISSED_KEY) === 'true'
    if (isDismissed) return false

    const hasActiveResiContract = leaseContractsList.some(
      (contract) =>
        !contract.isOperationsFrozen &&
        [...CONTRACT_ACTIVE_GROUP, ...CONTRACT_BOOKING_GROUP].includes(contract.leaseStatus)
    )
    if (hasActiveResiContract) return false

    return leaseContractsList.some((contract) => contract.isOperationsFrozen)
  }, [isLoading, leaseContractsList])

  const dismissVantageMigrationNotice = () => {
    localStorage.setItem(VANTAGE_MIGRATION_DISMISSED_KEY, 'true')
  }

  return {
    shouldShowVantageMigrationNotice,
    dismissVantageMigrationNotice,
    isLoading
  }
}
